module.exports = __webpack_public_path__ + "img/scene-defender.6dffae1c.svg";